import { fadeIn } from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const tcSection = document.querySelectorAll('.leadership-grid-section');

    tcSection.forEach((section) => {
        const tabTitles = section.querySelectorAll('.lgs-card-img.-bio, .lgs-card-name.-bio');
        const allTabContents = section.querySelectorAll('.lgs-popup-content');

        tabTitles.forEach(tabTitleEle => {
            tabTitleEle.addEventListener('click', function() {
                const parent = section.querySelector('.lgs-popup');

                // ✅ FIX 1: prevent null error
                if (!parent) {
                    return;
                }

                const isOpen = parent.classList.contains('is-show');
                if (isOpen) {return;}

                const targetSelector = this.dataset.href;
                document.body.classList.add('scroll-fixed');

                // ✅ FIX 2: NodeList → Array
                const targetContent = Array.from(allTabContents).find(
                    content => content.dataset.id === targetSelector,
                );

                // Remove active class from all tabs
                const allTabItems = parent.parentElement.children;
                Array.from(allTabItems).forEach(item => item.classList.remove('is-active'));

                // Hide all tab content
                allTabContents.forEach(content => {
                    content.style.display = 'none';
                });

                // Activate current
                parent.classList.add('is-show');

                if (targetContent) {
                    fadeIn(targetContent);
                }
            });
        });

        // Handle close popup
        section.addEventListener('click', function(e) {
            const closeBtn = e.target.closest('.lgs-popup-overlay');
            const overlay = e.target.closest('.lgs-popup-close');

            if (closeBtn || overlay) {
                document.body.classList.remove('scroll-fixed');
                section.querySelectorAll('.lgs-popup').forEach(el => {
                    el.classList.remove('is-show');
                    document.body.classList.remove('scroll-fixed');
                });
            }
        });
    });
});